import React, { FC, useEffect } from 'react'
import { Spinner, TextBody, Stack, TextHeading } from '@ally/metronome-ui'
import styled from 'styled-components'
import { useAriaLive } from '@ally/use-aria-live'

const StyledStack = styled(Stack)`
  margin: 50px 0;
`
const DEFAULT_DESCRIPTION = 'Loading your experience'

export const Loader: FC<{ description?: string }> = ({
  description = DEFAULT_DESCRIPTION,
}) => {
  const { announceAssertive } = useAriaLive()
  useEffect(() => {
    announceAssertive(`Just a moment, ${description}`)
  }, [description, announceAssertive])

  return (
    <StyledStack space="md" align="center">
      <Spinner />
      <TextHeading size="md">Just a moment</TextHeading>
      <TextBody tag="p" size="md">
        {description}
      </TextBody>
    </StyledStack>
  )
}
